<template>
	<div class="mob-module-container">
		<Empty v-if="!moduleList.length" class="modules-empty-wrap" />
		<template v-else>
			<!-- 菜单栏 -->
			<div v-if="showMobileHeader" class="mob-menu-bar-wrapper">
				<CMobileTabs :options="moduleList" :active.sync="activeModuleId" sync-key="moduleId" />
			</div>
			<!-- 内容区 -->
			<div class="mob-module-content-wrapper">
				<SimpleVScroll>
					<template v-for="item in moduleList">
						<SmartDisplayC
							v-if="activeModuleId === item.moduleId"
							:key="getModuleKey(item)"
							:compId="getModuleId(item)"
							mode="mob-full"
							v-bind="getModuleProps(item)"
						/>
					</template>
				</SimpleVScroll>
			</div>
		</template>
	</div>
</template>

<script setup>
import { computed, getCurrentInstance, ref, inject } from 'vue';
import { SimpleVScroll } from '@rebuild/components/scroll';
import SmartDisplayC from '@rebuild/components/SmartDisplayC.vue';
import { useModuleAttrs } from '@rebuild/hooks/useModuleAttrs';
import { useStoreCore } from '@/hooks';

const vm = getCurrentInstance();

const { shouldShowUI } = useStoreCore();
const showMobileHeader = computed(() => {
	if (!shouldShowUI('moduleBar')) return false;
	const len = moduleList.value.length;
	if (len <= 1) return false;
	return true;
});

const moduleList = ref([]);
const activeModuleId = ref();
const { getModuleId, getModuleProps, getModuleKey } = useModuleAttrs();

const templateMenus = inject('TEMPLATE_MENUS');
const getTemplateMenus = computed(() => templateMenus?.value || []);
const initMenuRender = () => {
	// 缩写: muid-菜单ID mid-模块id
	const { muid, mid } = vm.proxy.$route.query;

	let findMenu;
	const menuList = getTemplateMenus.value;
	if (muid) {
		findMenu = menuList.find(item => item.id == muid);
	} else {
		[findMenu] = menuList; // 默认选中第一个菜单
	}

	if (!findMenu) return;

	const moduleVOS = findMenu?.moduleVOS || [];
	moduleList.value = moduleVOS;

	const [fstModule] = moduleList.value;
	const findModule = mid ? moduleVOS.find(item => item.moduleId === mid) : fstModule;
	let activeModule;
	if (findModule) {
		activeModule = findModule;
	} else {
		activeModule = fstModule;
	}
	activeModuleId.value = activeModule?.moduleId;
};
initMenuRender();
</script>

<style lang="less" scoped>
.mob-module-container {
	display: flex;
	flex-direction: column;
	height: 100%;

	.mob-menu-bar-wrapper {
		flex-shrink: 0;
	}
	.mob-module-content-wrapper {
		flex: 1;
		height: 0;
	}
}
</style>
